// libraries.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiDocumentsPortal } from '@store/apiSlices/apiSlices';

// interfaces.
import {
  FieldRequirementItem,
  FieldRequirementsParams,
  FieldRequirementsResponse,
  FieldRequirementsMap,
} from '@domains/documents-review/interfaces/interfaces';

/**
 * field_requirements — política de campos obligatorios por país y business_type.
 *
 * La respuesta viene ENVUELTA: { results: [...], success: true } — no es un array pelado.
 * transformResponse la normaliza a un mapa { field_name: is_required } y solo confía en
 * `results` cuando `success === true`; ante cualquier otra forma devuelve {} para que el
 * consumidor (useFieldRequirements) caiga a los defaults actuales.
 */
export const fieldRequirements = apiDocumentsPortal.injectEndpoints({
  endpoints: builder => ({
    getFieldRequirements: builder.query<
      FieldRequirementsMap,
      FieldRequirementsParams
    >({
      query: ({ country, businessType }: FieldRequirementsParams) =>
        `/field_requirements?country=${country}&business_type=${businessType}`,
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getFieldRequirements',
        };
        return modelError;
      },
      transformResponse: (
        response: FieldRequirementsResponse
      ): FieldRequirementsMap => {
        if (!response?.success || !Array.isArray(response.results)) return {};
        return response.results.reduce<FieldRequirementsMap>(
          (acc, item: FieldRequirementItem) => {
            acc[item.field_name] = item.is_required;
            return acc;
          },
          {}
        );
      },
    }),
  }),
});

export const { useGetFieldRequirementsQuery } = fieldRequirements;
